<template>
  <div class="home">
    <!-- 🔄 Loader -->
    <div v-if="isLoading" class="loader-overlay">
      <div class="spinner"></div>
    </div>

    <!-- ✅ Hero Section -->
    <section
      v-else
      class="hero"
      :style="{ backgroundImage: 'url(' + images[currentImage] + ')' }"
    >
      <div class="overlay"></div>
      <div class="hero-content">
        <h1 class="main-title">MEDLAB</h1>
        <p class="subtitle">
          The Complete Laboratory Information<br />
          Management Software
        </p>
        
      </div>
    </section>

    <!-- Floating Action Buttons -->
    <div class="floating-menu">
      <a href="#" class="call" @click.prevent="handleCallClick">
        <i class="fas fa-phone"></i>
      </a>
      <a href="https://wa.me/919633011603" target="_blank" class="whatsapp">
        <i class="fab fa-whatsapp"></i>
      </a>
      <a
        href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@smartwaveindia.com&su=Request%20for%20Information&body=Hello%20Medlab%20Team"
        target="_blank"
        class="email"
      >
        <i class="fas fa-envelope"></i>
      </a>
    </div>

    <!-- Request Form Popup -->
    <div v-if="showRequestForm" class="request-form-popup">
      <div class="form-box">
        <h3>Request Form</h3>
        <input type="text" v-model="form.name" placeholder="Your Name" />
        <input type="text" v-model="form.phone" placeholder="Phone Number" />
        <textarea v-model="form.message" placeholder="Enter your request"></textarea>
        <div class="form-actions">
          <button @click="sendToWhatsApp">Send</button>
          <button @click="toggleRequestForm">Cancel</button>
        </div>
      </div>
    </div>
        <!-- ✅ New Info Section -->
    <section class="info-section">
      <div class="info-container">
        <div class="info-text">
          <h2>With <span>15+ years</span> of domain expertise</h2>
          <p>
            We offer more than a LIMS solution. Our development, design, and
            support teams collaborate with you to implement advanced ideas,
            enhance report quality, and drive continuous improvement in your
            lab operations.
          </p>
        </div>
        <div class="info-video">
          <video
            width="100%"
            height="300"
            controls
            autoplay
            muted
            loop
            playsinline
          >
            <source :src="require('@/assets/videos/medlab_overview.mp4')" type="video/mp4" />
              Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      images: [
        require("@/assets/images/pages/medlab1.webp"),
        require("@/assets/images/pages/medlab2.webp"),
        require("@/assets/images/pages/medlab3.webp"),
      ],
      currentImage: 0,
      intervalId: null,
      showRequestForm: false,
      isLoading: true,
      form: {
        name: "",
        phone: "",
        message: "",
      },
    };
  },
  mounted() {
    this.loadImages().then(() => {
      this.isLoading = false;
      this.startSlider();
    });
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    isMobile() {
      return /Android|iPhone|iPad|iPod|Windows Phone/i.test(
        navigator.userAgent
      );
    },
    handleCallClick() {
      if (this.isMobile()) {
        window.location.href = "tel:+919633011603";
      } else {
        this.showRequestForm = true;
      }
    },
    loadImages() {
      return new Promise((resolve) => {
        let loaded = 0;
        this.images.forEach((src) => {
          const img = new Image();
          img.src = src;
          img.onload = () => {
            loaded++;
            if (loaded === this.images.length) resolve();
          };
          img.onerror = () => {
            console.warn(`Image failed to load: ${src}`);
            loaded++;
            if (loaded === this.images.length) resolve();
          };
        });
      });
    },
    startSlider() {
      this.intervalId = setInterval(() => {
        this.currentImage = (this.currentImage + 1) % this.images.length;
      }, 5000);
    },
    toggleRequestForm() {
      this.showRequestForm = !this.showRequestForm;
    },
    sendToWhatsApp() {
      const { name, phone, message } = this.form;
      const text = `New Request Form Submission:\n\nName: ${name}\nPhone: ${phone}\nMessage: ${message}`;
      const url = `https://wa.me/919633011603?text=${encodeURIComponent(text)}`;
      window.open(url, "_blank");
      this.toggleRequestForm();
    },
  },
};
</script>

<style scoped>

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #206A98;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ✅ Hero Section */

.hero {
  min-height: 30vh;
  height: 762px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  position: relative;
  background-size: cover;
  background-position: top center;
  transition: background-image 1s ease-in-out;
  overflow: hidden;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

.hero-content {
  position: relative;
  z-index: 2;
  opacity: 0;
  animation: fadeIn 1.2s ease forwards;
  animation-delay: 0.3s;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
.main-title {
  font-size: 4rem;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 1rem;
}
.subtitle {
  font-size: 1.6rem;
  line-height: 1.5;
  margin-bottom: 2rem;
}

.floating-menu {
  position: fixed;
  right: 20px;
  top: 40%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 1000;
}
.floating-menu a {
  background: #fff;
  font-size: 20px;
  padding: 12px;
  border-radius: 50%;
  text-align: center;
  transition: background 0.3s, transform 0.2s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.floating-menu a:hover {
  background: #f0f0f0;
  transform: scale(1.1);
}

.floating-menu a i {
  color: #206A98;
}
.floating-menu a.whatsapp i {
  color: #25d366;
}
.floating-menu a.call i {
  color: #34b7f1;
}
.floating-menu a.email i {
  color: #d93025;
}


.request-form-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.form-box {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 350px;
  text-align: center;
}
.form-box input,
.form-box textarea {
  width: 100%;
  margin: 10px 0;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.form-actions button {
  background: #206A98;
  border: none;
  color: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}
.form-actions button:hover {
  background: #164a6b;
}
/* ✅ Info Section */
.info-section {
  background: #f9f9f9;
  padding: 80px 10%;
}

.info-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.info-text {
  flex: 1;
}

.info-text h2 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.info-text h2 span {
  color: #206A98;
  font-weight: 700;
}

.info-text p {
  font-size: 18px;
  color: #555;
  line-height: 1.7;
}

.info-video {
  flex: 1;
  display: flex;
  justify-content: center;
  
}
.info-video video {
  width: 100%;
  max-width: 700px;
  height: 300px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

}


/* ✅ Responsive */
@media (max-width: 768px) {
   .hero {
    min-height: 50vh;
  }
  .main-title {
    font-size: 2.8rem;
  }
  .subtitle {
    font-size: 1.2rem;
  }
  .info-container {
    flex-direction: column;
    text-align: center;
  }
  .info-video video {
    max-width: 100%;
    height: 250px;
  }
  .info-text h2 {
    font-size: 1.8rem;
  }
}
</style>

<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
/>
